<section class="afiliados mb-5">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Colegiados</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center text-center">
      <app-tabla-arquitectos></app-tabla-arquitectos>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
